<div class="epds_mat_override">
  <mat-card appearance="outlined">
<!--    not expecting to have a header and just let the tab title handle it? If end up using one, put in header here?-->
<!--    <mat-card-header fxLayout="row" fxLayoutAlign="center">-->
<!--        <mat-card-title role="heading" aria-level="1">Dashboard</mat-card-title>-->
        <!--          <mat-card-subtitle></mat-card-subtitle>-->
<!--    </mat-card-header>-->
    <mat-card-content fxLayout="row" fxLayoutAlign="end" fxLayoutGap="8px" class="no-bottom-pad">
      <div *appSpinner="loading; diameter: 40; color: 'primary'"></div>
      <div fxFlex=""></div>
      <button *ngIf="showEmailButton" mat-raised-button type="button" color="primary" (click)="onToggleEmailNotification()">Email {{emailButtonText}}</button>

      <mat-form-field floatLabel="always" appearance="outline" class="status-width">
        <mat-label>Case Status</mat-label>
        <mat-select #cs_select multiple ngModel panelWidth="auto" panelClass="epds-select-override"
                    [(ngModel)]="filterValues.status" (selectionChange)="selectionFilter($event)">
<!--          <mat-select-trigger>-->
<!--            {{cs_select.value?.toString() || ''}}-->
<!--            {{cs_select.value?.[0] || ''}}-->
<!--          </mat-select-trigger>-->
          <mat-option #cs_sa selectAll [allValues]="filterCaseStatusList" (trigger)="triggerFilter()">Select all</mat-option>
          <mat-divider></mat-divider>
          <mat-option *ngFor="let status of filterCaseStatusList" [value]="status">{{ status }}</mat-option>
        </mat-select>
        <button mat-icon-button *ngIf="filterValues.status.length > 0" matSuffix aria-label="Clear"
                (click)="filterValues.status=[]; cs_sa.deselect(); eventFilter($event); $event.stopPropagation()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field floatLabel="always" appearance="outline" class="group-width" *ngIf="showGroupAttorneyFilters">
        <mat-label>Group</mat-label>
        <mat-select ngModel panelWidth="auto" panelClass="epds-select-override"
                    [(ngModel)]="filterValues.group" (selectionChange)="selectionFilter($event)">
          <mat-option *ngFor="let group of filterGroupList" [value]="group">{{ group }}</mat-option>
        </mat-select>
        <button mat-icon-button *ngIf="filterValues.group != undefined" matSuffix aria-label="Clear"
                (click)="filterValues.group=undefined;eventFilter($event); $event.stopPropagation()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-form-field floatLabel="always" appearance="outline" class="attorney-width" *ngIf="showGroupAttorneyFilters">
        <mat-label>Attorney</mat-label>
        <mat-select ngModel panelWidth="auto" panelClass="epds-select-override"
                    [(ngModel)]="filterValues.user" (selectionChange)="selectionFilter($event)">
          <mat-option *ngFor="let attorney of filterAttorneyList" [value]="attorney">{{attorney}}</mat-option>
        </mat-select>
        <button mat-icon-button *ngIf="filterValues.user" matSuffix aria-label="Clear"
                (click)="filterValues.user='';eventFilter($event); $event.stopPropagation()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>
    </mat-card-content>
  </mat-card>

  <mat-card appearance="outlined">
    <mat-card-content class="mat-elevation-z8" fxLayout="column" class="no-bottom-pad">
      <div fxLayout>
        <div fxLayoutAlign="start" fxFlex="20">
          <mat-form-field floatLabel="always" appearance="outline">
            <mat-label>Filter</mat-label>
            <input matInput type="text" (keyup)="eventFilter($event)" #filterInput [(ngModel)]=filterValues.global>
            <button mat-icon-button *ngIf="filterValues.global" matSuffix aria-label="Clear"
                    (click)="filterValues.global='';eventFilter($event); $event.stopPropagation()">
              <mat-icon>close</mat-icon>
            </button>
          </mat-form-field>
        </div>
        <div fxFlex="80" fxLayoutAlign="end">
          <mat-paginator appPaginationSave [lsKey]="pageLocalStorageKey" [pageSizeOptions]="[5, 10, 25, 50, 100]"
                         showFirstLastButtons ></mat-paginator>
        </div>
      </div>
      <div class="scrollable-content">
        <table mat-table matSort [dataSource]="dataSource" (matSortChange)="util.announceSortChange($event)"
               matSortActive="submission_Date" matSortDirection="asc">
          <ng-container matColumnDef="b_No">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by B-Number"> B-Number </th>
            <td mat-cell *matCellDef="let protest">
              <app-dashboard-tree [protestParent]="protest"></app-dashboard-tree>
            </td>
          </ng-container>
          <ng-container matColumnDef="company_Name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Protester"> Protester </th>
            <td *matCellDef="let protest" mat-cell> {{protest.company_Name}} </td>
          </ng-container>
          <ng-container matColumnDef="submission_Date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Filing Date"> Filing Date </th>
            <td *matCellDef="let protest" mat-cell> {{protest.submission_Date}} </td>
          </ng-container>
          <ng-container matColumnDef="agency_Name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Agency"> Agency </th>
            <td *matCellDef="let protest" mat-cell> {{protest.agency_Name}} </td>
          </ng-container>
          <ng-container matColumnDef="agencyRepInfos" >
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Attorney Reps"> Attorney Reps </th>
            <td *matCellDef="let protest" mat-cell>
              <span *ngIf="!protest.agencyRepInfos">
                  Agency Reps. not yet assigned </span>
              <div *ngFor="let agencyRepInfo of protest.agencyRepInfos">
                <span>{{agencyRepInfo.lastName}} , {{agencyRepInfo.firstName}}  </span>
              </div>
            </td>
          </ng-container>
          <ng-container matColumnDef="due_Date">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Due Date"> Due Date </th>
            <td *matCellDef="let protest" mat-cell> {{protest.due_Date}} </td>
          </ng-container>
          <ng-container matColumnDef="a_No" >
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by EPDS Ctrl#"> EPDS Ctrl# </th>
            <td *matCellDef="let protest" mat-cell>
              <a (click)="redirectToCaseDocket(protest)" href="javascript:void(0)"
                 title="{{protest.a_No}}">{{protest.a_No}}</a>
            </td>
          </ng-container>
          <ng-container matColumnDef="po" >
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by PO"> PO </th>
            <td *matCellDef="let protest" mat-cell>{{protest.po}}</td>
          </ng-container>
          <ng-container matColumnDef="attorney_Group_Id">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Group #"> Group # </th>
            <td *matCellDef="let protest" mat-cell> Group {{protest.attorney_Group_Id}} </td>
          </ng-container>
          <ng-container matColumnDef="attorney_Name">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Attorney Name"> Attorney Name </th>
            <td *matCellDef="let protest" mat-cell> {{protest.attorney_Name}} </td>
          </ng-container>
          <ng-container matColumnDef="case_Type">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Case Type"> Case Type </th>
            <td *matCellDef="let protest" mat-cell> {{protest.case_Type | uppercase}} </td>
          </ng-container>
          <ng-container matColumnDef="case_Status">
            <th mat-header-cell *matHeaderCellDef mat-sort-header sortActionDescription="Sort by Case Status"> Case Status </th>
            <td *matCellDef="let protest" mat-cell> {{protest.case_Status}} </td>
          </ng-container>

          <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
          <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

          <!-- Row shown when there is no matching data. -->
          <tr class="mat-row" *matNoDataRow>
            <td class="mat-cell" colspan="5">Loading, no data, or nothing that matches the filter "{{filterInput.value}}"</td>
          </tr>
        </table>
      </div>
    </mat-card-content>
  </mat-card>
</div>
